import React from 'react';
import { Route, Redirect } from "react-router-dom";

class PrivateRoute extends React.Component {

  render() {
    const Main = this.props.components.main;
    const Sidebar = this.props.components.sidebar;

    return (
      <Route render={ props =>
        localStorage.getItem('expectSignIn') ? ( // Fixes firebase.auth not being ready after page reload
          <div className="wrapper">
            { Sidebar && (<Sidebar {...props} {...this.props.components} {...this.props.computedMatch} />) }
            { Main && (<Main {...props} {...this.props.components} {...this.props.computedMatch} />) }
          </div>
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: this.props.location } }} />
        )
      } />
    )
  }
}

export default PrivateRoute;
